import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "@mui/material";
import buildmuscle from "./images/buildmuscle.svg";
import caff from "./images/caff.svg";
import decaf from "./images/decaf.svg";
import fb_tooltip from "./images/fb_tooltip.jpg";
import gainweight from "./images/gainweight.svg";
import high from "./images/high.svg";
import keto from "./images/keto.svg";
import lactosefree from "./images/lactosefree.svg";
import loseweight from "./images/loseweight.svg";
import low from "./images/low.svg";
import vegan from "./images/vegan.svg";
import whey from "./images/whey.svg";
import styles from "./styles.module.scss";
const data = {
    protein_base: {
        title: "Choosing your protein base",
        data: [
            {
                title: "Whey Based Blend",
                image: whey,
                text: "Classic formula that blends whey concentrate and whey isolate for a rich tasting protein",
            },
            {
                title: "Plant-Based Blend",
                image: vegan,
                text: "Made with organic pea protein + organic brown rice protein. Supports vegan and vegetarian diets.",
            },
            {
                title: "Low Lactose Whey",
                image: lactosefree,
                text: "Crafted from ultra-filtered whey protein isolate and fast-absorbing carbohydrates. 98% lactose-free to prevent bloating.",
            },
            {
                title: "Ketogenic Blend",
                image: keto,
                text: "Help fuel your ketosis with this great-tasting blend of ultra-filtered whey protein isolate and MCTs. Made with virtually lactose-free and fast-digesting protein.",
            },
        ],
    },
    protein_goal_boost: {
        title: "Choosing your goal",
        data: [
            {
                title: "Build Muscle",
                image: buildmuscle,
                text: "Formulated to have a high protein density to support muscle growth",
            },
            {
                title: "Lose Weight",
                image: loseweight,
                text: "Formulated to support your metabolism and weight loss goals with lower carbohydrates and higher protein ",
            },
            {
                title: "Gain Weight",
                image: gainweight,
                text: "Formulated with added carbohydrates to encourage weight gain",
            },
        ],
    },
    protein_flavor: {
        title: "Choosing your flavor boosts",
        data: [],
        hardcoded: (_jsxs("div", { className: styles.flavorStickModal, children: [_jsx("p", { children: "Change up your flavor daily. Our protein powder is intentionally flavorless, allowing you to customize your protein shake however you like. Simply add one of our 8 delightful flavor boosts whenever you prepare your shake." }), _jsxs("div", { className: styles.greenBox, children: [_jsx("p", { children: "1 flavor boost pack includes" }), _jsx("p", { children: "7 single serving flavor sticks" })] }), _jsx("div", { className: styles.imgContain, children: _jsx("img", { src: fb_tooltip, alt: "Gainful products and flavors" }) })] })),
    },
    hydration_caffeine: {
        title: "Caffeinated versus non-caffeinated",
        data: [
            {
                title: "Caffeinated Hydration",
                image: caff,
                text: "Contains 150mg to 200mg of Caffeine and 250mg of L-theanine for a jitter-free, clean energy boost.",
            },
            {
                title: "Non-caffeinated Hydration",
                image: decaf,
                text: "Crafted for anytime hydration. Reap the benefits of hydrating without the caffeine",
            },
        ],
    },
    hydration_sweat: {
        title: "Choosing your sweat level",
        data: [
            {
                title: "Moderate Sweat",
                image: low,
                text: "Contains moderate levels of 4 key electrolytes: 300mg of sodium, 150mg of magnesium, 50mg of calcium and 150mg of potassium",
            },
            {
                title: "High Sweat",
                image: high,
                text: "Contains higher levels of 4 key electrolytes: 400mg of sodium, 200mg of magnesium, 50mg of calcium and 150mg of potassium",
            },
        ],
    },
    preworkout_caffeine: {
        title: "Choosing caffeine level",
        data: [
            {
                title: "Caffeinated Pre-Workout",
                image: caff,
                text: "Contains 150mg - 200mg of caffeine and 250mg of l-theanine for a jitter-free, clean energy boost. Equivalent to 1.5 cups of coffee.",
            },
            {
                title: "Non-caffeinated Pre-Workout",
                image: decaf,
                text: "Crafted with BCAAs, Beta Alanine, L-citrulline, and Creatine to improve muscular performance without Caffeine. Perfect for evening workout sessions.",
            },
        ],
    },
    preworkout_stim: {
        title: "Choosing stimulant level",
        data: [
            {
                title: "High Stim",
                image: caff,
                text: "Formulated with higher levels of BCAAs, caffeine, creatine & leucine for high intensity workouts",
            },
            {
                title: "Medium Stim",
                image: caff,
                text: "Formulated with moderate levels of BCAAs, caffeine, creatine & leucine for moderate intensity workouts",
            },
            // {
            //   title: "Low Stim",
            //   image: caff,
            //   text: "Boosted with BCAAs, caffeine & leucine",
            // },
        ],
    },
};
const ToolTip = ({ open, data_key, closeModal, }) => {
    return (_jsxs(Dialog, { classes: {
            paper: styles.modal_root,
        }, open: open, onClose: closeModal, children: [_jsx("button", { onClick: closeModal, className: styles.x_mark, children: _jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("line", { x1: "1.20711", y1: "1.29289", x2: "15.2071", y2: "15.2929", stroke: "#333333", strokeWidth: "2" }), _jsx("line", { x1: "0.792893", y1: "15.2929", x2: "14.7929", y2: "1.29289", stroke: "#333333", strokeWidth: "2" })] }) }), _jsxs("div", { children: [_jsx("h4", { className: styles.rhodeTitle, children: data[data_key]["title"] }), _jsx("hr", { className: styles.shortHR }), _jsxs("div", { className: styles.content, children: [data[data_key]["data"].map((item) => (_jsxs("div", { children: [_jsxs("div", { className: styles.titleAndImage, children: [_jsx("h5", { className: styles.title, children: item.title }), _jsx("img", { src: item.image, alt: item.title, height: 35, width: 35 })] }), _jsx("p", { className: styles.text, children: item.text })] }, item.title))), data[data_key].hardcoded] })] })] }));
};
export default ToolTip;
